import React from "react";
import styles from './FJStockVideoHeaderClose.module.less';
import FJClose from "../../../../common/component/FJClose/FJClose";

function FJStockVideoHeaderClose(props) {
	return (
		<div className={styles.close} onClick={props.onClick}>
			<FJClose />
		</div>
	)
}

export default FJStockVideoHeaderClose;